import { createAction, createAsyncAction } from "typesafe-actions";
const domain = "transaction-download";
const transactionActions = {
  transactionDownloadCsv: createAsyncAction(
    `${domain}/transactionWithUserProfileDownloadCsvRequest`,
    `${domain}/transactionWithUserProfileDownloadCsvSuccess`,
    `${domain}/transactionWithUserProfileDownloadCsvFailed`
  )(),
  retryTransaction: createAsyncAction(
    `${domain}/retryTransactionRequest`,
    `${domain}/retryTransactionSuccess`,
    `${domain}/retryTransactionFailure`
  )(),
  deleteTransaction: createAsyncAction(
    `${domain}/deleteTransactionRequest`,
    `${domain}/deleteTransactionSuccess`,
    `${domain}/deleteTransactionFailure`
  )(),
  downloadBulkP2PTransferTemplate: createAction(`${domain}/downloadBulkP2PTransferTemplate`)()
};
export {
  transactionActions
};
//# sourceMappingURL=actions.js.map
